import React, { Component } from 'react';
import { Row, Col, Icon, Divider, Tooltip } from 'antd';

export default class AccountModal extends Component {
    constructor(props) { super(props); }
    render() {
        const { closeEvent } = this.props;
        return (
            <div>
                <div className='ss-cmpts-acct-modal-close' onClick={closeEvent}>
                    <Tooltip placement='left' title='Close'>
                        <Icon type='close'/>
                    </Tooltip>
                </div>
                <Row type='flex' justify='space-around' align='middle'>
                    <Col>
                        <div className='ss-cmpts-acct-modal-title'>
                            <Icon type='user' style={{ marginRight: '15px' }} />
                            <span style={{ fontWeight: 'bold' }}>
                                {'Account'}
                            </span>
                        </div>
                    </Col>
                </Row>
                <Divider style={{ margin: '15px 0px' }} />
            </div>
        )
    }
}
